import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ResumeDescriptionProduct = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  padding: ${spacing(5)} ${spacing('xl')};
  height: fit-content;
`;

export const $ResumeProduct = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing('lg')};
`;

export const $ResumeProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
`;

export const $ResumeInfoProductTitle = styled.div`
  font-weight: ${fontWeight('medium')};
  ${fontStyle('base')};
  line-height: 19px;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing('sm')};
`;

export const $ResumeModalOpenButtonContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
